import { useQuery } from '@tanstack/react-query';
import { useUniversalNavContext } from '../../universal-nav/hooks';
export const useQueryAccountNotifications = (currentAccountId, categories) => {
    const { apiHostname } = useUniversalNavContext();
    const result = useQuery({
        queryKey: ['account', currentAccountId, categories],
        queryFn: async () => {
            if (!currentAccountId)
                throw new Error('No currentAccountId specified.');
            const url = new URL(`/api/v4/accounts/${encodeURIComponent(currentAccountId)}/notifications`, apiHostname || window.location.origin);
            if (categories === null || categories === void 0 ? void 0 : categories.length) {
                const searchParams = new URLSearchParams();
                categories.forEach((category) => searchParams.append('categories', category));
                url.search = searchParams.toString();
            }
            const response = await fetch(url.toString(), {
                credentials: process.env.NODE_ENV !== 'test' ? 'include' : 'same-origin',
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const json = await response.json();
            return json;
        },
        select: formatAccountNotificationsData,
        enabled: !!currentAccountId,
    });
    return Object.assign(Object.assign({}, result), { isLoading: result.isInitialLoading });
};
const formatAccountNotificationsData = (rawData) => {
    var _a;
    return (_a = rawData === null || rawData === void 0 ? void 0 : rawData.results) !== null && _a !== void 0 ? _a : [];
};
//# sourceMappingURL=useQueryAccountNotifications.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
